import { hide, show } from "../utils/helpers";

export default class Site {
  constructor() {
    this.siteForm = document.querySelector('.site-form');
    if (this.siteForm) {
      this.cmsSelect = $('.cms-deployment-select');
      this.cmsSelect.chosen().change(this.updateVisibilityAndRules.bind(this))
      this.updateVisibilityAndRules();
    }

    this.sitePreviewContainer = document.querySelector('#site-preview');
    if (this.sitePreviewContainer) {
      const actionsBar = this.sitePreviewContainer.querySelector('.actions-bar');
      const buttons = actionsBar.querySelectorAll('.btn');
      for (const button of buttons) {
        button.addEventListener('click', this.onClickSitePreviewAction.bind(this, button));
      }
    }
  }

  onClickSitePreviewAction(button) {
    const { action, view } = button.dataset;
    const iframe = this.sitePreviewContainer.querySelector('#site-preview-frame');

    const actions = {
      'resize': () => {
        const size = this.getIframeSize(view);
        iframe && (iframe.className = size + ' d-block mx-auto');
      },
      'fullscreen': () => {
        const icon = button.querySelector('i');
        icon.classList.toggle('fa-expand-alt');
        icon.classList.toggle('fa-compress-alt');
        this.sitePreviewContainer.classList.toggle('fullscreen')
      },
    }

    return actions[action]();
  }

  getIframeSize = (view) => ({
    'mobile': 'w-xs-410p h-xs-740p',
    'tablet': 'h-xs-760p mw-1000p w-100',
    'desktop': 'w-100 h-100',
  }[view]);

  updateVisibilityAndRules() {
    const clusterSelect = document.querySelector('.js-cluster-select')
    const validator = window.solodev.formValidators[this.siteForm.id];
    if (this.cmsSelect.children('option:selected').hasClass('new-cms')) {
      show(clusterSelect);
      validator.addFieldValidation(this.siteForm.id+'[my_cluster_id]', 'notBlank', {
        'message': 'Please choose a cluster.'
      });
    } else {
      hide(clusterSelect);
      validator.removeFieldValidation(this.siteForm.id+'[my_cluster_id]');
      validator.addFieldValidation(this.siteForm.id+'[my_deployment_id]', 'notBlank', true, {
        'message': 'Please choose a CMS.'
      });
    }
  }
}
